import { render } from "./LivingSpacesView.vue?vue&type=template&id=57350c62"
import script from "./LivingSpacesView.vue?vue&type=script&lang=js"
export * from "./LivingSpacesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__